import forEach from 'dcode/functions/forEach'
import getSlug from './getSlug'

/**
 * Создает маппинг между slug и value (ID)
 * @param {Object} basic - Данные из API
 * @returns {Object} - Объект вида { slug: value, ... }
 */
export default function getSlugMap (basic) {
  const data = [...(basic?.main || []), ...(basic?.other || [])]
  const slugMap = {}
  const valueToSlugMap = {}

  forEach(data, sections => {
    if (sections?.value) {
      const sectionSlug = sections.slug || getSlug(sections.text)
      slugMap[sectionSlug] = sections.value
      valueToSlugMap[sections.value] = sectionSlug
    }
    forEach(sections?.list, item => {
      if (item?.value) {
        const itemSlug = item.slug || getSlug(item.text)
        slugMap[itemSlug] = item.value
        valueToSlugMap[item.value] = itemSlug
      }
    })
  })

  return {
    slugToValue: slugMap,
    valueToSlug: valueToSlugMap
  }
}
